import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import TransactionLink from "../../../TransactionLink";
import dayjs from 'dayjs';
import {Type} from "../../../../redux/Transaction/helper";
import AmountTd, {AmountTdWidth} from "../../../Table/Common/AmountTd";
import React from "react";
import ContactName from "bukku/components/Columns/Reports/Common/ContactName";

function getColumns(props) {
    const { companyCurrencySymbol } = props;

    return [
        {
            title: t`Date`,
            dataIndex: 'date',
            key: 'date',
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData: record }) => {
                switch (record.rowType) {
                    case 'total':
                        return t`TOTAL`;
                    default:
                        return (
                            <TransactionLink
                                transaction={{
                                    id: record.id,
                                    type: Type.sale_payment,
                                }}
                                label={dayjs(record.date).format('DD/MM/YYYY')}
                            />
                        );
                }
            },
        },
        {
            title: t`No.`,
            dataIndex: 'number',
            key: 'number',
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData: record }) => {
                switch (record.rowType) {
                    case 'total':
                        return null;
                    default:
                        return (
                            <TransactionLink
                                transaction={{
                                    id: record.id,
                                    type: Type.sale_payment,
                                }}
                                label={record.number || '-'}
                            />
                        );
                }
            },
        },
        {
            title: t`Contact`,
            dataIndex: 'contact_name',
            key: 'contact_name',
            width: 0,
            flexGrow: 20,
            cellRenderer: ({ rowData: record }) => {
                switch (record.rowType) {
                    case 'total':
                        return null;
                    default:
                        return (
                            <ContactName
                                contact_id={record.contact_id}
                                contact_name={record.contact_name}
                                contact_code={record.contact_code}
                            />
                        );
                }
            },
        },
        {
            title: t`Contact Code`,
            dataIndex: 'contact_code',
            key: 'contact_code',
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData: record }) => record.contact_code,
        },
        {
            title: t`Invoice Date`,
            dataIndex: 'invoice_date',
            key: 'invoice_date',
            width: 0,
            flexGrow: 16,
            cellRenderer: ({ rowData: record }) => {
                if (record.rowType !== 'total')
                    return record.invoice_date ? dayjs(record.invoice_date).format('DD/MM/YYYY') : '-';
                return null;
            },
        },
        {
            title: t`Taxable Amount`,
            dataIndex: 'taxable_amount',
            key: 'taxable_amount',
            align: 'right',
            width: AmountTdWidth,
            cellRenderer: ({ rowData: record }) => (
                <AmountTd
                    currency_code={companyCurrencySymbol}
                    amount={record.taxable_amount}
                    style={{width: '100%'}}
                />
            ),
        },
        {
            title: t`Tax Amount`,
            dataIndex: 'tax_amount',
            key: 'tax_amount',
            align: 'right',
            width: AmountTdWidth,
            cellRenderer: ({ rowData: record }) => (
                <AmountTd
                    currency_code={companyCurrencySymbol}
                    amount={record.tax_amount}
                    style={{width: '100%'}}
                />
            ),
        },
    ];
}

export default {
    storageKey: StorageKey.report_sst_past_prepayments,
    required: [
        'date',
        'number',
        'contact_name',
        'contact_code',
        'invoice_date',
        'taxable_amount',
        'tax_amount',
    ],
    defaulto: [],
    getReportLabel: () => t`Service Tax for Past Prepayments`,
    getColumns,
};
